










































import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import SearchBar from '@/components/SearchBar.vue';
import Grid from '@/components/Grid.vue';
import GridFileItem from '@/components/GridFileItem.vue';
import LoadingSpinner from '@/components/LoadingSpinner.vue';
import { SearchActions } from '@/store/search/actions.enum';
import OpenFileMixin from '@/mixins/open-file';

export default Vue.extend({
  name: 'Search',

  mixins: [OpenFileMixin],

  components: {
    SearchBar,
    Grid,
    GridFileItem,
    LoadingSpinner,
  },

  computed: {
    ...mapGetters('search', ['items', 'loading']),
  },

  methods: {
    ...mapActions('search', {
      searchFiles: SearchActions.SEARCH,
      resetSearch: SearchActions.RESET,
    }),

    search(val: string) {
      this.searchFiles(val);
    },
  },
});
